import React from "react";

function TestingPage() {
  return <div className="min-h-screen p-5 text-neutral-500">TestingPage</div>;
}

export default TestingPage;
